import React, { FunctionComponent, useEffect, useState, useMemo, useCallback, useRef } from "react";
import cx from "classnames";
import styles from "./fixedTable.module.less";
import { ICharts } from "@Types/kindSumReport";
import { TextBox } from "./common";

export interface tabType {
  title: string;
  image: string;
  values: Array<string> | string;
  type: "images" | "image";
  relationChartId: number;
}

interface IProps {
  type?: string;
  title?: string;
  dataSource: ICharts;
}

const firstHeaderWidth = 100;

const FixedTable: FunctionComponent<IProps> = ({ title, dataSource }) => {
  const targetRef = useRef<HTMLDivElement>(null);
  const [isShowPrew, setPrew] = useState<boolean>(false);

  const table = useMemo(() => dataSource.chartData as tabType[][], [dataSource]);
  const thead = useMemo(() => (!!table.length ? table[0] : []), [table]);
  const tbody = useMemo(() => (!!table.length ? table.slice(1, table.length) : []), [table]);

  const scrollTo = useCallback((scrollValue) => {
    let scrollLeft = targetRef.current!.scrollLeft;
    targetRef.current!.scrollTo(scrollLeft + scrollValue, 0);
  }, []);

  const handleScroll = () => {
    setPrew(!!targetRef.current!.scrollLeft);
  };

  useEffect(() => {
    if (targetRef.current) {
      targetRef.current.addEventListener("scroll", handleScroll);
      () => targetRef.current && targetRef.current.addEventListener("scroll", handleScroll);
    }
  }, []);

  return (
    <div
      className={cx(styles["fixed-table"], {
        [styles["fixed"]]: thead.length > 3,
      })}
    >
      {title && <TextBox text={title} />}
      <div className={cx(styles["table-container"], { [styles["table-scroll"]]: isShowPrew })}>
        {isShowPrew && <div className={styles["prev"]} onClick={() => scrollTo(-784)}></div>}
        <div className={styles["table-content"]} ref={targetRef}>
          <table style={{ width: thead.length > 3 ? thead.length * firstHeaderWidth : "100%" }}>
            <colgroup>
              {thead.map((_, inx) =>
                !inx ? (
                  <col style={{ width: firstHeaderWidth }} key={inx}></col>
                ) : (
                  <col
                    key={inx}
                    style={{
                      width:
                        thead.length < 3 ? ((268 - firstHeaderWidth) / (thead.length - 1) / 268) * 100 + "%" : "auto",
                    }}
                  ></col>
                ),
              )}
            </colgroup>
            <thead className={styles["table-thead"]}>
              <tr>
                {thead.map((item, inx) => (
                  <th className={styles["table-header table-cell-fix-left"]} key={inx}>
                    {item.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className={styles["table-tbody"]}>
              {tbody.map((item, inx) => (
                <tr key={inx}>
                  {item.map((i, idx) => (
                    <td className={styles["table-cell"]} key={idx}>
                      {i.title ? i.title : "-"}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {thead.length > 3 && <div className={styles["next"]} onClick={() => scrollTo(784)}></div>}
      </div>
    </div>
  );
};

export default FixedTable;
